import { PERMISSIONS } from '@optiflow/types';

/**
 * What taking an optical order needs, grant by grant: reading the customer, taking the pair, reading the prescriptions it can be made to, finding frames and lenses, and the sale itself.
 *
 * The entry and the route ask for all of them, so nobody is shown a way in they cannot finish; the API refuses the same callers regardless. No role is named.
 */
export const OPTICAL_BUILDER_PERMISSIONS: string[] = [
  PERMISSIONS.CUSTOMERS_VIEW,
  PERMISSIONS.OPTICAL_CREATE,
  PERMISSIONS.OPTICAL_VIEW,
  PERMISSIONS.CATALOG_VIEW,
  PERMISSIONS.SALES_CREATE,
];

/** Reading a confirmed optical order: the order and the jobs on it. */
export const OPTICAL_SUMMARY_PERMISSIONS: string[] = [
  PERMISSIONS.SALES_VIEW,
  PERMISSIONS.OPTICAL_VIEW,
];

/** Tracking a job, reading its ticket and the branch queue: optical.view alone. What a user may do to a job is asked action by action. */
export const OPTICAL_TRACKING_PERMISSIONS: string[] = [PERMISSIONS.OPTICAL_VIEW];
